import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import MacCryptogramUploadFile from "./MacCryptogramUploadFile";
import MacServiceManagement from "./MacServiceManagement";
import MacMasterKeyBinding from "./MacMasterKeyBinding";
import Encryption from "./MacEncryption";

function MacKeyManagementTabs(props) {
    const [activeTab, setActiveTab] = useState(1);
    const [path, setPath] = useState();
    const history = useHistory();
    const location = useLocation();
    const tabs = [
        {
            name: "MAC Crypotogram File",
            path: "/MackeyManagement",
        },
        /*{
            name: "Service Management",
            path: "/MackeyManagement/serviceMgmt",
        },*/
        {
            name: "MAC MasterKey Binding",
            path: "/MackeyManagement/macMasterKeyBind",
        },
        {
            name: "MACEncryption",
            path: "/MackeyManagement/macEncryption",
        },
    ];
    useEffect(() => {
        setPath(location.pathname);
    }, [location.pathname]);

    const renderTab = () => {
        if (path === "/MackeyManagement") {
            return <MacCryptogramUploadFile />;
        } else if (path === "/MackeyManagement/serviceMgmt") {
            return <MacServiceManagement />
        } else if (path === "/MackeyManagement/macMasterKeyBind") {
            return <MacMasterKeyBinding />;
        } else if (path === "/MackeyManagement/macEncryption") {
            return <Encryption />;
        }
    }

    return (
        <>
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
                {tabs.map((tab, index) => (
                    <li className="nav-item">
                        <a
                            className={`nav-link ${path === tab.path && "active"}`}
                            data-toggle="tab"
                            href="#tb_key_mgmt"
                            role="tab"
                            onClick={() => history.push(`${tab.path}`)}
                        >
              <span className="d-block d-sm-none">
                <i className="fas fa-address-card"></i>
              </span>
                            <span
                                className="d-none d-sm-block"
                                style={{ whiteSpace: "pre-line" }}
                            >
                {tab.name}
              </span>
                        </a>
                    </li>
                ))}
            </ul>
            <div className="tab-pane" role="tabpanel">
                {renderTab()}
            </div>
        </>
    );
}

export default MacKeyManagementTabs;
